module.exports = __webpack_public_path__ + "img/link-banner-id.96aa7ade.png";